export default __webpack_public_path__ + "static/media/Git.bf47e1af.md";